import React, { useMemo } from 'react'

import { t } from 'i18next'

import { ButtonNavLink } from '~/components/Buttons'
import { history } from '~/helpers'

import { useCampaignForm } from '../hooks/useCampaignForm'

const HandleStrategies: React.FC = () => {
  const { availableStrategies, selectedStategyCampaign } = useCampaignForm()

  const buttons = useMemo(() => {
    const currentPath = history.location.pathname
    const currentSearchParams = new URLSearchParams(history.location.search)
    const currentAvailableStrategies = availableStrategies.filter(
      s => s !== selectedStategyCampaign
    )

    return currentAvailableStrategies.map(strategy => {
      const updatedParams = new URLSearchParams(currentSearchParams)
      updatedParams.set('strategy', strategy)

      return {
        key: strategy,
        text: t(`rm:campaign.create.strategies.change.${strategy}`),
        to: `${currentPath}?${updatedParams.toString()}`
      }
    })
  }, [availableStrategies, selectedStategyCampaign])

  if (availableStrategies?.length <= 1) return null

  return (
    <footer className="text-center fs-6 border-top mt-3 py-3">
      {buttons?.map(({ key, ...props }) => (
        <ButtonNavLink
          key={key}
          template="transparent"
          size="small"
          {...props}
        />
      ))}
    </footer>
  )
}

export default HandleStrategies
